 <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
   <div class="grid m-0">
     <ng-container *ngFor="let route of routes">
       <div class="w-full p-2">
   
         <p-fieldset [legend]="route.header" [toggleable]="true">
           <div class="grid m-0">
             <ng-container *ngFor="let func of route.routings">
                <ng-container *ngIf="func.path">
                  <p-button [routerLink]="[func.path]" [outlined]="true" class="route-container col-12 w-16rem h-10rem md:col-6 lg:col-3" [label]="func.label">
                    <p-tag *ngIf="func.badgeIcon" [icon]="func.badgeIcon"></p-tag>
                    <p-tag *ngIf="func.badge" [value]="func.badge"></p-tag>
                    <i class="{{func.icon}}" style="font-size: 2.2rem"></i>
                  </p-button>
                </ng-container>
                <ng-container *ngIf="func.action">
                  <p-button (onClick)="func.action()" [outlined]="true" class="route-container col-12 w-16rem h-10rem md:col-6 lg:col-3" [label]="func.label">
                    <p-tag *ngIf="func.badgeIcon" [icon]="func.badgeIcon"></p-tag>
                    <p-tag *ngIf="func.badge" [value]="func.badge"></p-tag>
                    <i class="{{func.icon}}" style="font-size: 2.2rem"></i>
                  </p-button>
                </ng-container>
   
             </ng-container>
           </div>
         </p-fieldset>
       </div>
     </ng-container>
   </div>
 </p-scrollPanel>
